import { createRouter, createWebHistory } from 'vue-router';
import LoginPage from '@/views/LoginPage.vue';
import RegisterPage from '@/views/RegisterPage.vue';
import ForgotPassword from '@/views/ForgotPassword.vue';
import NotFound from '@/views/NotFound.vue';
import AddStock from '@/views/AddStock.vue';
import AddProduct from '@/views/AddProduct.vue';
import AddProductItems from '@/views/AddProductItems.vue';
import EditProducts from '@/views/EditProducts.vue';
import Help from '@/views/Help.vue';
import AboutPage from '@/views/AboutPage.vue';
import SettingsPage from '@/views/SettingsPage.vue';
import LoaderUI from '@/components/LoaderUI.vue';

const routes = [
    { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound },
    { path: '/forgot-password', name: 'ForgotPassword', component: ForgotPassword },
    { path: '/', name: 'LoginPage', component: LoginPage },
    { path: '/register', name: 'RegisterPage', component: RegisterPage },
    { path: '/branch/:branchName', name: 'BranchView', component: () => import('../views/BranchView.vue'), props: true, meta: { requiresAuth: true } },
    { path: '/add-stock', name: 'AddStock', component: AddStock, meta: { requiresAuth: true } },
    { path: '/add-product', name: 'AddProduct', component: AddProduct, meta: { requiresAuth: true } },
    { path: '/add-product-items', name: 'AddProductItems', component: AddProductItems, meta: { requiresAuth: true } },
    { path: '/edit-products', name: 'EditProducts', component: EditProducts, meta: { requiresAuth: true } },
    { path: '/help', name: 'Help', component: Help, meta: { requiresAuth: true } },
    { path: '/about', name: 'AboutPage', component: AboutPage, meta: { requiresAuth: true } },
    { path: '/settings', name: 'SettingsPage', component: SettingsPage, meta: { requiresAuth: true } },
    { path: '/loader', name: 'LoaderUI', component: LoaderUI, meta: { requiresAuth: true } },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

// Flag to prevent multiple simultaneous checks
let isCheckingAuth = false;

router.beforeEach(async (to, from, next) => {
    const { useAuthStore } = await import('@/stores/auth');
    const authStore = useAuthStore();

    // Add a small delay to ensure store is synced
    await new Promise(resolve => setTimeout(resolve, 100));
    
    // Wait for auth check if not initialized
    if (!authStore.initialized && !isCheckingAuth) {
        isCheckingAuth = true;
        try {
            await authStore.checkAuth();
        } catch (err) {
            console.error('Auth check failed:', err);
        } finally {
            isCheckingAuth = false;
        }
    }
    
    // Check if route requires authentication
    if (to.meta.requiresAuth && !authStore.isAuthenticated) {
        authStore.clearAuth();
        next('/');
        return;
    }
    
    // Redirect authenticated users away from login/register
    if ((to.path === '/' || to.path === '/register') && authStore.isAuthenticated) {
        const branchName = authStore.getShopName || 'Main';
        next(`/branch/${branchName}`);
        return;
    }
    
    next();
});

export default router;
